const mobileBreakpoint = 49;
function isMobile() {
    return window.matchMedia(`(max-width: ${mobileBreakpoint}rem)`).matches;
}
function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function prefersDark() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
export { mobileBreakpoint, isMobile, prefersReducedMotion, prefersDark };
